// extracted by mini-css-extract-plugin
export default {"problemList":"styles_problemList__0yEKJ","table":"styles_table__tF8hr","thead":"styles_thead__-ydcS","tbody":"styles_tbody__2B0AW"};